// extracted by mini-css-extract-plugin
export default {"card":"FallbackMessage__card___q9Xix","messageWrapper":"FallbackMessage__messageWrapper___yJH0f"};